export const formatThousandSeparator = (
	num: number,
	locale: Intl.LocalesArgument = 'en-US'
): string => {
	if (isNaN(num)) {
		throw new Error('Invalid number input');
	}

	return new Intl.NumberFormat(locale).format(num);
};
